/* tslint:disable */
/* eslint-disable */
/**
 * topi Seller API
 * # Localization  Strings returned can be localized when the _Accept-Language_ header is provided in the request. It should follow the [RFC-2616 convention](http://www.ietf.org/rfc/rfc2616.txt).
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
/**
 * Check if a given object implements the ProductStandardIdentifier interface.
 */
export function instanceOfProductStandardIdentifier(value) {
    let isInstance = true;
    return isInstance;
}
export function ProductStandardIdentifierFromJSON(json) {
    return ProductStandardIdentifierFromJSONTyped(json, false);
}
export function ProductStandardIdentifierFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'identifierType': !exists(json, 'identifier_type') ? undefined : json['identifier_type'],
    };
}
export function ProductStandardIdentifierToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'identifier_type': value.identifierType,
    };
}
